//リンク先選択画面
import React, { useEffect } from 'react';
import styled from 'styled-components';
import { Dialog, DialogActions, DialogContent, DialogTitle } from '@material-ui/core';
import { Grid, Typography, Button, Card } from '@material-ui/core';
import LinkIcon from '@material-ui/icons/Link';
import { WorkAreaStateType } from './BookEditor';
import { useDispatch } from 'react-redux';
import useOneArrowDb from '../hooks/useOneArrowDb';
import { setDefaultSheet } from '../redux/sheetDbSlice';
import useSheetTreeNamesForLink, { LinkSheetNameType } from '../hooks/useSheetTreeNamesForLink';
import useCurrentBookDb from '../hooks/useCurrentBookDb';

const LineCard = styled(Card)`
  padding: 8px;
  margin: 8px;
  transition: background-color 300ms;
  &:hover {
    background-color: #f5f5f5;
    cursor: pointer;
  }
`
const LargeLinkIcon = styled(LinkIcon)`
  position: relative;
  top: 8px;
  font-size: 32px;
`

type JumpArrowLinkDialogProps = {
  open: boolean;
  onClose: () => void;
  onEditArrowClose: () => void;
  id?: string;
  nodeClicked: (workArea: WorkAreaStateType, id?: string) => void;
}
const JumpArrowLinkDialog: React.FC<JumpArrowLinkDialogProps> = ({open, onClose, onEditArrowClose, id, nodeClicked}) => {
  const dispatch = useDispatch();
  const arrowValue = useOneArrowDb(id);
  const bookDb = useCurrentBookDb();
  const linkedSheetNames:LinkSheetNameType[] = useSheetTreeNamesForLink(bookDb?.name, arrowValue?.links);

  useEffect(() => {
    if (arrowValue && arrowValue.links?.length === 1) {
      nodeClicked('sheet', arrowValue.links[0]);
      dispatch(setDefaultSheet(arrowValue.links[0]));
      onClose();
    }
  }, [open])

  const jumpToLinkedSheet = (sheetId:string) => {
    nodeClicked('sheet', sheetId);
    dispatch(setDefaultSheet(sheetId));
    onClose();
    onEditArrowClose();
  }

  return (
    <Dialog open={open} onClose={onClose} maxWidth='lg' fullWidth>
      <DialogTitle>クリックするとリンク先のシートへジャンプします</DialogTitle>
      <DialogContent>
        { arrowValue?.links?.map((linkedSheetId, index) => {
          return(
          <LineCard>
            <Grid container spacing={1} onClick={() => jumpToLinkedSheet(linkedSheetId)}>
              <Grid container>
                <Grid item xs={1}><LargeLinkIcon /></Grid>
                <Grid item xs={11}>
                    <Typography variant="caption">{linkedSheetNames[index].linkTreeName}</Typography>
                </Grid>
              </Grid>
              <Grid container>
                <Grid item xs={1}></Grid>
                <Grid item xs={11}>
                  <Typography variant="body1">{linkedSheetNames[index].sheetName}</Typography>
                </Grid>
              </Grid>
            </Grid>
          </LineCard>
        )
        })}
      </DialogContent>
      <DialogActions>
        <Button variant='text' color='primary' onClick={onClose}>
          キャンセル
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default JumpArrowLinkDialog;
